import { useItemsDisplayValues } from 'root/hooks/useItemsDisplayValues';

export const useLabelLogic = () => {
  const { showItemLabelsName, useLabelIconColor } = useItemsDisplayValues();

  return {
    hideTooltip: showItemLabelsName,
    useLabelIconColor,
  };
};
